import { AppProfile } from '../../../components/app/App'
import { Box, CircularProgress } from '@mui/joy'

import ProfileContentShow from '../../../components/module/ProfileContentShow/ProfileContentShow';
import { useParams } from 'react-router-dom';
import { useUser } from '../../../hooks/user/useUser';
import { usePosts } from '../../../hooks/post/usePosts';
import { useScrollRestoration } from '../../../hooks/service/useScrollRestoration';
import ServerError from '../../../components/module/ServerError/ServerError';

function PageShowUser({ format = "id", side = false }) {
    format = ['id', 'username'].includes(format) ? format : 'id';
    const { username, id } = useParams();

    const { user, loading, error, restriction } = useUser({ format, username, id });

    const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim();
    const seoTitle = user ? (fullName ? `${fullName} (@${user.username})` : `@${user.username}`) : undefined;
    const seoDesc = user
        ? (user.description || `Профиль ${fullName || '@' + user.username} в Аквариум — мессенджере с записями.`)
        : undefined;
    const seoImage = user?.avatar
        ? (user.avatar.startsWith('http') ? user.avatar : `${process.env.REACT_APP_API_URL}${user.avatar}`)
        : undefined;

    return (
        <AppProfile
            title={seoTitle}
            desc={seoDesc}
            image={seoImage}
            og={{ 'og:type': 'profile' }}
        >
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <ServerError title={error} desc="" />
            ) : user ? (
                <ProfileContentShow
                    user={user}
                    side={side}
                    restriction={restriction}
                />
            ) : null}
        </AppProfile>
    )
}

export default PageShowUser
